export enum GoalType {
  User = 'USER',
  Schedule = 'SCHEDULE',
  Course = 'COURSE',
  Syllabus = 'SYLLABUS',
}
